module.exports = __webpack_public_path__ + "9a22278e8c1733311004a59c7bab84d8.svg";